export const FED_PAYMENT_TYPES_ACTIONS=  [
  "create_fed_payment",
  "create_fed_payment_template",
  "create_fed_svc_payment",
  "create_fed_svc_payment_template",
  "create_fed_drawdown_payment",
  "create_fed_drawdown_payment_template"
];
